import React from 'react';
import './Footer.css'; // Import CSS file for styling
import etcmcLogo from './etcmcLogo1.png'; // Import the logo image

const Footer = () => {

  const handleRedirectToPage = (url) => {
    window.location.href = url;
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>
          <img src={etcmcLogo} alt="ETCMC Logo" className="footer-logo" /> &copy; 2024 ETCMC
        </p>
        <div className="footer-buttons">
          <button className="button redirect-btn" onClick={() => handleRedirectToPage('https://etcmc-membership-mint.netlify.app/')}>DAO Membership</button>
          <button className="button redirect-btn" onClick={() => handleRedirectToPage('https://stake.etcmc.org/')}>Stake</button>
          <button className="button redirect-btn" onClick={() => handleRedirectToPage('https://pool.etcmc-monitor.org/')}>ETC Pool</button>
          <button className="button redirect-btn" onClick={() => handleRedirectToPage('https://etcmc.org/dao')}>About</button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
